import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../../services/api";
import SectionHeader from "../include/SectionHeader";

const BlogDetails = () => {
  const { slug } = useParams();

  const [blog, setBlog] = useState(null);
  const [relatedBlogs, setRelatedBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    api.get(`/api/blogs/${slug}`)
      .then(res => {
        const currentBlog = res.data.blog;
        const otherBlogs = res.data.other_blogs || [];

        const allBlogs = [currentBlog, ...otherBlogs];

        allBlogs.sort(
          (a, b) => new Date(b.blog_date) - new Date(a.blog_date)
        );

        setBlog(currentBlog);
        setRelatedBlogs(allBlogs);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  const shareUrl = window.location.href;
  const shareText = blog?.title;

  const BlogDetailsSkeleton = () => (
    <div className="blog-details-section py-5">
      <div className="container">
        <div className="row">

          <div className="col-md-8 col-12">
            <div className="skeleton">

              <div className="skeleton-line long shimmer"></div>
              <div className="skeleton-line medium shimmer"></div>

              <div
                className="skeleton shimmer mb-4"
                style={{ height: "520px", borderRadius: "12px" }}
              ></div>

              <div className="skeleton-line short shimmer"></div>

              {[1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="skeleton-line long shimmer"></div>
              ))}
            </div>
          </div>

          <div className="col-md-4 col-12">
            <div className="skeleton">

              <div className="skeleton-line medium shimmer mb-3"></div>

              {[1, 2, 3].map((i) => (
                <div key={i} className="">
                  <div
                    className="skeleton shimmer"
                    style={{ width: "100%", height: "250px", borderRadius: "8px" }}
                  ></div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </div>
  );

  if (loading) return <BlogDetailsSkeleton />;
  if (!blog) return null;

  return (
    <div className="blog-details-section py-5">
      <div className="container">
        <div className="row">

          <div className="col-md-9 col-12">
            <div className="blog-details-content">

              {blog.main_image && (
                <div className="blog-main-image-wrapper mb-3">
                  <img
                    src={`${process.env.REACT_APP_WEB_URL}${blog.main_image}`}
                    alt={blog.title}
                    className="blog-details-image"
                  />
                </div>
              )}

              <div className="share-inline-box">
                <h4>
                  Share This Post
                  <span className="blog-date ms-3">
                    {new Date(blog.blog_date).toLocaleDateString("en-GB")}
                  </span>
                </h4>
                
                <div className="share-inline-icons">

                  <a
                    href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
                      shareUrl
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="facebook"
                  >
                    <i className="fa-brands fa-facebook"></i>
                  </a>

                  <a
                    href={`https://wa.me/?text=${encodeURIComponent(
                      shareText + " " + shareUrl
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp"
                  >
                    <i className="fa-brands fa-whatsapp"></i>
                  </a>

                  <a
                    href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
                      shareText
                    )}&url=${encodeURIComponent(shareUrl)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="twitter"
                  >
                    <i className="fa-brands fa-x-twitter"></i>
                  </a>

                  <a
                    href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
                      shareUrl
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="linkedin"
                  >
                    <i className="fa-brands fa-linkedin"></i>
                  </a>

                </div>
              </div>

              <div>
                <h4 className="section-title blog-details-title">{blog.title}</h4>
              </div>

              <div className="blog-details-text">
                {blog.content.map((block, index) => (
                  <div className="mb-4" key={index}>
                    {block.title && (
                      <h4 className="section-subtitle">{block.title}</h4>
                    )}
                    <div dangerouslySetInnerHTML={{ __html: block.content }} />
                  </div>
                ))}
              </div>
            </div>
          </div>
          
          <div className="col-md-3 col-12">
            {relatedBlogs.length > 0 && (
              <div className="related-blog-sidebar">
                <SectionHeader title="Blogs" />

                {relatedBlogs.map((item) => {
                  const isActive = item.slug === slug;

                  return (
                    <div
                      key={item.id}
                      className={`blog-card position-relative mb-3 sidebar-blog-card ${
                        isActive ? "active" : ""
                      }`}
                    >
                      <Link to={`/blog-details/${item.slug}`}>
                        <div className="blog-card-image">
                          <img
                            src={`${process.env.REACT_APP_WEB_URL}${item.main_image}`}
                            alt={item.title}
                            className="img-fluid"
                          />
                        </div>
                      </Link>

                      <div className="blog-card-content">
                        <h4 className="section-subtitle text-white mb-0 text-start">
                          {item.title}
                        </h4>
                        <span className="author text-white">{item.author}</span>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default BlogDetails;
